import user from './user'
import game from './game'
import news from './news'
import chip from './chip'
import baccarat from './baccarat'

export default { user, game, news, chip, baccarat }



// WEBPACK FOOTER //
// ./resources/assets/js/app/api/index.js